import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURSpinModel from "../models/BURSpinModel";

export class BURHasCascadeCondition implements ICondition {
    public check(): boolean {
        if (!BURSpinModel.cascades.length) return false;
        return (
            BURSpinModel.current_cascade_index < BURSpinModel.cascades.length
        );
    }
}
